import { useParams } from "react-router-dom";
import { DirectoryDetailView } from "./DirectoryDetailView";

export function VendorDetailPage() {
  const { name } = useParams();
  const decoded = name ? decodeURIComponent(name) : "";

  if (!decoded) return null;

  return <DirectoryDetailView entityType="vendor" entityName={decoded} />;
}

(VendorDetailPage as unknown as { path: string }).path = "/vendors/:name";
